import React, { useState } from "react";
import LoaderMessage from "../components/LoaderMessage";

const withFetchingHandler = (Component) => {
  const NewComponent = ({ data, chatHead, message }) => {
    if (data === null) {
      return <LoaderMessage message="Loading... ⌛" />;
    } else if (data?.length <= 0) {
      return <LoaderMessage message={message} />;
    }

    return (
      <>
        <Component allMessages={data} chatHead={chatHead} />
      </>
    );
  };
  return NewComponent;
};

export default withFetchingHandler;
